<template>
    <svg width="35" height="29" viewBox="0 0 35 29" xmlns="http://www.w3.org/2000/svg">
        <path d="M17.454 25.43a1.581 1.581 0 0 1-2.591 1.217l-8.644-7.166h-4.6a1.581 1.581 0 0 1-1.585-1.578v-6.3a1.581 1.581 0 0 1 1.581-1.582h4.6l8.644-7.163a1.582 1.582 0 0 1 2.596 1.223V25.43h-.001zm6.08-2.471h-.114a1.58 1.58 0 0 1-1.118-.463l-.211-.212a1.58 1.58 0 0 1-.153-2.06 9.194 9.194 0 0 0-.243-11.267 1.58 1.58 0 0 1 .109-2.115l.211-.211c.314-.32.752-.489 1.2-.461.446.022.863.232 1.146.578a12.663 12.663 0 0 1 .33 15.576c-.275.37-.697.602-1.157.635zm6.537 4.887c-.286.338-.7.541-1.142.56h-.066a1.58 1.58 0 0 1-1.118-.463l-.208-.208a1.581 1.581 0 0 1-.092-2.136 16.851 16.851 0 0 0-.282-22.018 1.581 1.581 0 0 1 .064-2.164l.207-.208A1.539 1.539 0 0 1 28.6.744c.436.013.847.204 1.136.53 6.697 7.544 6.839 18.86.333 26.569l.002.003z" fill="#043D89" fill-rule="nonzero"/>
    </svg>
</template>

<script>
export default {
    name: 'IconSpeaker',
};
</script>
